module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-main', {
    staticClass: "not-found"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "data-qa": "Content-Logo-Image",
      "src": "/src/assets/img/admin-logo.png"
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('notFoundTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notFoundDescription')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons-block"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('notFoundButtonHomeText')))])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.goSupportPage
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('notFoundButtonSupportText')))])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fccb24ac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound/NotFound.vue
// module id = 989
// module chunks = 3